module.exports = __webpack_public_path__ + "static/media/halugen-box-small.22ebde7a.jpg";